import { render, staticRenderFns } from "./QuickPayPageHuizhoupeixun03.vue?vue&type=template&id=21393734&scoped=true"
import script from "./QuickPayPageHuizhoupeixun03.vue?vue&type=script&lang=js"
export * from "./QuickPayPageHuizhoupeixun03.vue?vue&type=script&lang=js"
import style0 from "./QuickPayPageHuizhoupeixun03.vue?vue&type=style&index=0&id=21393734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21393734",
  null
  
)

export default component.exports